module.exports = __webpack_public_path__ + "static/olatosi-f18c53c112ca698f8d140e231cdb0992.png";